export default __webpack_public_path__ + "static/media/offer.e39d2926.png";